import UrlManager from 'manager/urlManager'
import Utils from 'common/utils';
import WeatherParams from 'models/weatherParams';
import Constants from 'common/constants'
import Network from 'common/network'

class LocationSuggestionsDataSource {
    getSuggestionsForLocation(locStr, responseHandler) {
        return new Promise((resolve, reject) => {
            if (Utils.isEmptyStr(locStr)) {
                reject(new Error("location-string cannot be empty!"))
                return
            }

            let url = `${UrlManager.getLocationSuggestionEndpoint()}?location=${encodeURIComponent(locStr)}`
            Network.fetchWithTimeout(url)
                .then((response) => {
                    if (false === response.ok) {
                        throw Error(response.statusText)
                    }
                    return response.json()
                })
                .then((resp) => {
                    let success = resp["success"]
                    if (Utils.isNull(success) || success !== true) {
                        throw new Error("Did not get success as true")
                    }

                    let formattedData = this.formatLocSuggestionResp(resp["data"])
                    resolve(formattedData)
                })
                .catch((e) => {
                  console.log(e);
                })
        })
    }

    formatLocSuggestionResp(respData) {
        return new Promise((resolve, reject) => {
            if (Utils.isNull(respData)) {
                reject(new Error("Response data from request is empty!"))
                return
            }

            let locations = respData["locations"]
            if (Utils.isNull(locations) || locations.length === 0) {
                reject(new Error("No locations data in the response"))
                return
            }

            let locationsList = []
            for (let i = 0; i < locations.length; i++) {
                let loc = locations[i]
                let city = loc["_key_"]
                let latLonList = loc["value"]
        
                if (Utils.isNull(city) || Utils.isNull(latLonList) || latLonList.length <2) {
                    continue
                }

                // Format the lat-lon-list
                let weatherData = new WeatherParams(latLonList[0], latLonList[1], null, city, latLonList[2], null, Constants.WEATHER_SRC.MANUAL)
                locationsList.push(weatherData)
            }

            resolve(locationsList)
        })
    }
}

let instance = new LocationSuggestionsDataSource()
export default instance


// WEBPACK FOOTER //
// ./src/dataSource/locationSuggestionsDataSource.js